/** Up to two initials from a name, for an avatar with no image. */
const initials = (name: string) =>
  name
    // Words only: "SO-Bangkok - KTEST" gives SB, not S-.
    .split(/[^0-9A-Za-zÀ-ÖØ-öø-ÿ]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

export default initials;
